/* eslint-disable no-restricted-syntax */
import React from 'react';
import Icon from '@ant-design/icons';
import BriefCaseIcon from './BriefCaseIcon';
import DoubleFontIcon from './DoubleFontIcon';
import FontIcon from './FontIcon';
import GlassesIcon from './GlassesIcon';
import UserIcon from './UserIcon';
import SettingIcon from './SettingIcon';

const iconStyle = {
  display: 'inline-block',
  verticalAlign: 'middle'
};

const BriefCase = props => <Icon style={iconStyle} component={BriefCaseIcon} {...props} />;
const DoubleFont = props => <Icon style={iconStyle} component={DoubleFontIcon} {...props} />;
const Font = props => <Icon style={iconStyle} component={FontIcon} {...props} />;
const Glasses = props => <Icon style={iconStyle} component={GlassesIcon} {...props} />;
const User = props => <Icon style={iconStyle} component={UserIcon} {...props} />;
const Setting = props => <Icon style={iconStyle} component={SettingIcon} {...props} />;

export {
  BriefCase,
  DoubleFont,
  Font,
  Glasses,
  User,
  Setting
};
